import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';

import styles from './SbRespContentModuleRegular.scss';

function SbRespContentModuleRegularComponent({ browseContentModule }) {
    const { description, title, photo } = browseContentModule;

    return (
        <div className={styles.info}>
            <ExpandableContent
                collapseHeight={240}
                buttonClassName={styles.button}
                dataTn="facet-creator-info"
            >
                {photo && (
                    <img className={styles.photo} src={photo} data-tn="facet-creator-picture" />
                )}
                <div className={styles.title} data-tn="facet-creator-title">
                    {title}
                </div>
                <span
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            </ExpandableContent>
        </div>
    );
}

SbRespContentModuleRegularComponent.propTypes = {
    browseContentModule: PropTypes.object.isRequired,
};

export const SbRespContentModuleRegular = createFragmentContainer(
    SbRespContentModuleRegularComponent,
    {
        browseContentModule: graphql`
            fragment SbRespContentModuleRegular_browseContentModule on ContentModuleRegular {
                description
                title
                photo
            }
        `,
    }
);
